import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-no-data-select',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="nhsuk-form-group mb-0">
      <label class="nhsuk-label" [for]="fieldName">{{ label }}</label>
      <select class="nhsuk-select" [class]="{ 'not-empty': isNotEmpty(fieldName) }" [id]="fieldName" [name]="fieldName">
        <option value="-1" selected>{{ placeholder || '-- No data found --' }}</option>
      </select>
    </div>
  `,
  styleUrl: './no-data-select.component.css',
})
export class NoDataSelectComponent {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() placeholder?: string;
  @Input() isNotEmpty!: (fieldName: string) => boolean;
}
